import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { UserStore } from 'src/Stores/User/UserStore';
import { IUser, IUserRole } from '../../../../Interfaces/UserInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput, EInputMask } from '../../../EInput';


@inject('stores')
@observer
class AdminUserDetails extends React.Component {
    private mask = new EInputMask();
    public props: any;
    public userDetails: IUser = new IUser();
    public userRoles: IUserRole[] = [];
    public usersDisposer: any;
    public rolesDisposer: any;
    public adminStore: any;
    public errorStore: any;
    public MessageStore: any;
    public UserStore: UserStore;
    public passwordsDontMatch: boolean = true;

    public state = {
        isDirty: false,
        passwordsDontMatch: this.passwordsDontMatch,
        redirect: false,
        selectedRoles: [] as string[],
        userDetails: this.userDetails,
        userName: '',
        userRoles: this.userRoles,
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.errorStore = this.props.stores.ErrorsStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveUser = this.handleSaveUser.bind(this);
        this.handleRoleSelect = this.handleRoleSelect.bind(this);
    }

    public componentDidMount() {
        
        this.createDisposers();

        this.adminStore.getUserRoles();
        
        this.setState({
            userName: this.props.match.params.userName,
        }, () => {
            if ( this.state.userName !== 'new' ) {
                this.adminStore.getUserDetails(this.state.userName);
            }
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    private createDisposers() {
        this.usersDisposer = intercept(this.adminStore, 'userDetails', (change: any) => {
            this.setState({
                userDetails: change.newValue
            }, () => {
                this.addUserRoles();
            });
            return change;
        });

        this.rolesDisposer = intercept(this.adminStore, 'userRoles', (change: any) => {
            this.setState({
                userRoles: change.newValue
            });

            return change;
        });
    }

    private clearDisposers() {
        this.usersDisposer();
        this.rolesDisposer();
    }

    private displayUserName() {
        return this.state.userDetails.firstName + ' ' + this.state.userDetails.lastName;
    }

    private addUserRoles() {
        const user = this.state.userDetails;
        const roles: any[] = [];

        if ( user.roles ) {
            user.roles.map((role: any) => {
                roles.push(role);
            });
            
            this.setState({
                selectedRoles: roles,
            });
        }
    }

    public handleChange(event: any) {
        const userDetails = this.state.userDetails;

        if (event.target.name === 'email' && userDetails.email === userDetails.notificationEmail) {
            userDetails.email = event.target.value;
            userDetails.notificationEmail = userDetails.email;
        } else if (event.target.name === 'phoneNumber' && userDetails.phoneNumber === userDetails.phoneMobile) {
            userDetails.phoneNumber = this.mask.phone(event.target.value);
            userDetails.phoneMobile = this.mask.phone(event.target.value);
        } else if (event.target.name.includes('phone')) {
            userDetails[event.target.name] = this.mask.phone(event.target.value);
        } else {
            userDetails[event.target.name] = event.target.value;
        }
        this.setState({
            isDirty: true,
            userDetails
        });
    }

    public handleRoleSelect(event: any) {
        event.persist();

        const user = this.state.userDetails;
        const selecteds: any[] = [];

        for ( const option of event.target.options) {
            if ( option && option.selected ) {
                selecteds.push(option.value);
            }
        }

        user.roles = selecteds;
        this.setState({
            isDirty: true,
            selectedRoles: selecteds,
            user,
        });
    }

    public handleSaveUser() {
        let areYouSure = true;
        if (this.state.userDetails.status !== 'Active') {
            areYouSure = confirm(`Setting the user's status to ${this.state.userDetails.status} will remove the user from the Active Users List and revoke the user's access to the App.\n\nAre you sure you want to revoke the user's access?`);
        }

        if (areYouSure) {

            if ( this.state.userName === 'new' ) {
                this.adminStore.postUser(this.state.userDetails)
                .then(
                    (data: any) => {
                        if(data) {
                            this.MessageStore.addMessage(
                                'User was successfully created',
                                'success'
                                );
                                this.setState({isDirty: false});
                            }
                        }
                        );
            } else {
                this.adminStore.putUser(this.state.userDetails)
                .then(
                    (data: any) => {
                        if(data) {
                            
                            this.setState({
                                redirect: true
                            });
                            const message = 'Changes have been saved';
                            
                            this.MessageStore.addMessage(
                                message,
                                'success'
                                );
                            }
                    });
            }
        }
    }

    public confirmPasswordMatch() {
        const hasError = ( this.state.userDetails.password !== this.state.userDetails.confirmPassword );

        this.setState({
            passwordsDontMatch: !hasError
        });
    }

    public isRoleSelected = () => {
        const user = this.state.userDetails;
        if (Array.isArray(user.roles) && user.roles.length > 0) {
            return true;
        }
        return false;
    }

    public handleChangeRadio = (event: any) => {
        const userDetails = this.state.userDetails;
        userDetails.status = event.target.value;
        this.setState({
            userDetails
        });
    }

    private filterSuperAdminRole = (role: IUserRole) => {
        if (role.name === 'SuperAdmin' && this.UserStore.user.roles && !this.UserStore.user.roles.some(r => r === 'SuperAdmin')) {
            return false;
        }
        return true;
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/users" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row className="header">
                        <Col md="12">
                            {this.state.userDetails.firstName === '' ? (
                                <h2 className="float-left">Add New User</h2>
                            ) : (
                                <h2 className="float-left">User Detail for {this.displayUserName()}</h2>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>First Name</Label>
                                <EInput 
                                    type="text" 
                                    name="firstName"
                                    required={true} 
                                    value={this.state.userDetails.firstName} 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Last Name</Label>
                                <EInput 
                                    type="text" 
                                    name="lastName"
                                    required={true} 
                                    value={this.state.userDetails.lastName} 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Email / Username</Label>
                                <EInput 
                                    type="text" 
                                    name="email" 
                                    required={true}
                                    value={this.state.userDetails.email} 
                                    data-validation="email" 
                                    disabled={this.state.userName !== 'new'}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Notifications Email</Label>
                                <EInput 
                                    type="text" 
                                    name="notificationEmail" 
                                    required={true}
                                    value={this.state.userDetails.notificationEmail} 
                                    data-validation="email" 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup check={true}>
                                <Label check={true}>
                                    <Input
                                        type="radio"
                                        name="Active"
                                        value="Active"
                                        checked={this.state.userDetails.status === 'Active'}
                                        onChange={this.handleChangeRadio}
                                        />{'  '}
                                    Active
                                </Label>
                            </FormGroup>
                            {
                                this.state.userDetails.id !== '' &&
                                <React.Fragment>
                                    <FormGroup check={true}>
                                        <Label check={true}>
                                            <Input
                                                type="radio"
                                                name="Active"
                                                value="Inactive"
                                                checked={this.state.userDetails.status === 'Inactive'}
                                                onChange={this.handleChangeRadio}
                                            />{'  '}
                                            Inactive
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true}>
                                        <Label check={true}>
                                            <Input
                                                type="radio"
                                                name="Active"
                                                value="Removed"
                                                checked={this.state.userDetails.status === 'Removed'}
                                                onChange={this.handleChangeRadio}
                                            />{'  '}
                                            Removed
                                        </Label>
                                    </FormGroup>
                                </React.Fragment>
                            }
                            {/* Commented out as part of new system generated passwords
                            <Row>
                                <Col md="6" className={(!this.state.passwordsDontMatch) ? 'passwords-not-matched' : 'passwords-matched'}>
                                    <FormGroup>
                                        <Label>Password</Label>
                                        <Input 
                                            type="password" 
                                            name="password"
                                            value={this.state.userDetails.password} 
                                            onChange={this.handleChange}
                                            />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Confirm Password</Label>
                                        <Input 
                                            type="password" 
                                            name="confirmPassword"
                                            value={this.state.userDetails.confirmPassword} 
                                            onChange={this.handleChange}
                                        />
                                    </FormGroup>
                                    <p className="matched-message">Passwords do not match. Please try again.</p>
                                </Col>
                            </Row> */}
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Location</Label>
                                <EInput 
                                    type="text" 
                                    name="location"
                                    value={this.state.userDetails.location} 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Notifications Mobile Phone</Label>
                                <EInput 
                                    type="text" 
                                    name="phoneNumber"
                                    required={true} 
                                    value={this.state.userDetails.phoneNumber} 
                                    data-mask="phone" 
                                    data-validation="phone"
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Mobile Phone</Label>
                                <EInput 
                                    type="text" 
                                    name="phoneMobile"
                                    value={this.state.userDetails.phoneMobile} 
                                    data-mask="phone" 
                                    data-validation="phone"
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Alternate Phone</Label>
                                <EInput 
                                    type="text" 
                                    name="phoneAlternate"
                                    value={this.state.userDetails.phoneAlternate} 
                                    data-mask="phone" 
                                    data-validation="phone"
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Roles</Label>
                                <EInput
                                    type="select"
                                    name="selectedRoles"
                                    multiple={true}
                                    size="10"
                                    onChange={this.handleRoleSelect}
                                    value={this.state.selectedRoles}
                                >
                                    {this.state.userRoles.filter(this.filterSuperAdminRole).map((role: IUserRole, index: any) =>
                                        <option key={index} value={role.name}>{role.name}</option>
                                    )}
                                </EInput>
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        (this.state.userDetails.id === '' ?
                        this.UserStore.hasPermission('Permissions.Admin.Users.Create')
                        :
                        this.UserStore.hasPermission('Permissions.Admin.Users.Update'))
                        &&
                        <ButtonRow>
                            <EButton color="primary" onClick={this.handleSaveUser} disabled={!this.isRoleSelected()}>Save User</EButton>
                        </ButtonRow>

                    }
                </div>
            )
        );
    }

}

export default AdminUserDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Users/AdminUserDetails.tsx